import { Ticket } from "lucide-react";
import Footer from "../components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-8">
          <span className="genre-badge text-primary border-primary mb-4 inline-block">
            LEGAL
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl font-black text-foreground">
            Terms of Service
          </h1>
          <p className="text-muted-foreground mt-2">Last updated: January 2025</p>
        </div>

        <div className="bg-card border border-border p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              1. Role of XTrip
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              XTrip is a travel aggregator and retailer. We facilitate bookings between you (the Customer) 
              and third-party Travel Providers (Airlines, Hotels, and Event Organisers like Resident Advisor/Dice.fm). 
              We do not own, operate, or control the events or travel services.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              2. Liability
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              XTrip is not responsible for event cancellations, postponements, or changes in itinerary. 
              All bookings are subject to the specific Rules and Restrictions of the final Travel Provider.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              3. Travel Documents
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              It is your responsibility to ensure you have valid passports, visas, and health documentation 
              (e.g., travel insurance) for your destination.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              4. Pricing
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Prices are live and subject to change until the booking is confirmed by the provider.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              5. Contact
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              For support contact{" "}
              <a 
                href="mailto:hello@xtriptour.com" 
                className="text-primary hover:underline"
              >
                hello@xtriptour.com
              </a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
